import colors from 'vuetify/es5/util/colors';
import { Theme, VuetifyThemeVariant } from 'vuetify/types/services/theme';

// Any color names added to theme will need to be added to this interface
interface IExtendedTheme extends VuetifyThemeVariant {
    gray: string;
}
export default {
    dark: false,
    themes: {
        light: {
            primary: '#00609c',
            secondary: '#c017a2',
            accent: '#97caeb',
            gray: '#00609c',
            error: '#DF0000',
            warning: colors.amber.lighten2,
            info: colors.lightBlue.lighten2,
            success: colors.green.lighten2,
        } as Partial<IExtendedTheme>,
        dark: {
            primary: '#00609c',
            secondary: '#c017a2',
            accent: '#97caeb',
            gray: '#00609c',
            error: '#DF0000',
            warning: colors.amber.darken2,
            info: colors.lightBlue.darken2,
            success: colors.green.darken2,
        } as Partial<IExtendedTheme>,
    },
    options: {
        // inject color vars into html root element
        customProperties: true,
    },
} as Theme;
